import { getOpensOrdersDetails, OpenOrdersDetailsApiParameter } from "@dana/Services/DanaOrderRelatedService";
import {OpenOrdersDetailActions} from "@dana/Store/Data/OpenOrders/Reducers/GetOpenOrdersDetailReducer";
import { CancelValidationResponse } from "@dana/Types/ApiModels";
import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import { DispatchProp } from "react-redux";

type OpenOrderDetailRequestParameter = {
    orderNumber?: string; 
    poNumber?: string;      
}& HasOnSuccess<any> & HasOnError;


type HandlerType =ApiHandlerDiscreteParameter<OpenOrderDetailRequestParameter,OpenOrdersDetailsApiParameter,CancelValidationResponse, DispatchProp<OpenOrdersDetailActions>>;

export const SetLoadingOn: HandlerType = props => {
    props.dispatch?.({
        type: "OpenOrdersDetail/IsLoading",
        isLoading: true,
    });
}

export const SendDataToApi: HandlerType = async props => {
    props.apiResult = await getOpensOrdersDetails({
        orderNumber:props.parameter.orderNumber,
        poNumber:props.parameter.poNumber,
    });   
};

export const PopulateFacetResult: HandlerType = props => {
    if (props.apiResult) {
        props.dispatch?.({
            type: "OpenOrdersDetail/PopulateResult",              
            data: props.apiResult,
        } as any);
    }
}

export const chain = [SetLoadingOn,SendDataToApi, PopulateFacetResult];

const GetOpenOrdersDetailData = createHandlerChainRunner(chain, "GetOpenOrdersDetailData");
export default GetOpenOrdersDetailData;